<template>
    <div id="checkpay" class="checkpay">
        <!-- 510 전문(params) 자동제출 폼 — iframe(checkpayframe)으로 쿠콘 결제창을 띄운다 -->
        <form ref="form" :action="url" method="post" target="checkpayframe" style="display: none">
            <input v-for="(value, key) in params" :key="key" type="hidden" :name="key" :value="value" />
        </form>

        <div v-show="show" class="checkpay__overlay">
            <div class="checkpay__modal">
                <button type="button" class="checkpay__close" aria-label="닫기" @click="cancel">×</button>
                <iframe ref="frame" name="checkpayframe" class="checkpay__frame" marginwidth="0" marginheight="0" frameborder="no" scrolling="auto" />
                <div v-show="loading" class="checkpay__progress"><div class="spinner" /></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import { listenParent, clearChannel } from "@/plugins/pg-result-bridge";

// 결과 전달 통로 이름. pages/plugins/checkpay/result.vue 가 같은 이름으로 보낸다.
const CHANNEL = "checkpay-result";

export default {
    data() {
        return {
            show: false,
            loading: false,

            url: null,
            params: {},

            completed: false,
            dispose: null,
        };
    },
    mounted() {
        // 결과 result.vue(쿠콘 복귀 → /pay → /plugins/checkpay/result, iframe 내부)가 호출한다.
        window.checkpayComplete = (payload) => this.onComplete(payload);
        window.checkpayClose = () => {
            this.close();
            this.$emit("close");
        };

        // 결제창이 www 없는 호스트로 돌아오면 위 직접 호출은 다른 출처라 막힌다 — postMessage 등
        // 출처가 달라도 닿는 통로를 함께 듣는다 (2026-09-09 운영 장애: 결제는 됐는데 창이 안 닫힘).
        this.dispose = listenParent(CHANNEL, (payload) => this.onComplete(payload));
    },
    beforeDestroy() {
        window.checkpayComplete = undefined;
        window.checkpayClose = undefined;
        this.dispose?.();
    },
    methods: {
        /** 통로가 여럿이라 같은 결과가 두 번 이상 올 수 있다 — 처음 것만 받는다. */
        onComplete(payload) {
            if (this.completed) return;
            this.completed = true;
            clearChannel(CHANNEL);

            this.close();
            this.$emit("complete", payload);
            this.$emit("change", payload);
            this.$emit("input", payload);
        },
        close() {
            this.show = false;
            this.loading = false;
        },
        cancel() {
            this.close();
            this.$emit("close");
        },
        /**
         * 결제 시작: /request 로 전문을 받아 폼을 쿠콘에 자동제출(iframe)한다.
         * @param {{ orderNo: string, ci: string, membCd?: string }} [param0]
         */
        async open({ orderNo, ci, membCd } = {}) {
            this.completed = false;
            clearChannel(CHANNEL);

            this.show = true;
            this.loading = true;

            try {
                const { checkout } = await api.plugins.checkpay.request({ orderNo, ci, membCd });

                this.url = checkout.url;
                this.params = checkout.params;

                this.$nextTick(() => {
                    // 기본: iframe(target="checkpayframe")으로 결제창 표시.
                    // 쿠콘이 프레이밍을 막을 경우(X-Frame-Options/CSP) 팝업으로 전환:
                    //   const popup = window.open("", "checkpayPopup", "width=500,height=640,resizable=no,scrollbars=yes");
                    //   if (!popup) return alert("팝업이 차단되어 있습니다. 팝업 차단을 해제한 뒤 다시 시도해주세요.");
                    //   this.$refs.form.target = "checkpayPopup";
                    this.$refs.form.submit();
                    this.loading = false;
                });
            } catch (error) {
                this.close();
                this.$emit("close");
                throw error;
            }
        },
    },
};
</script>

<style scoped>
.checkpay__overlay {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
/* PC: 가운데 정렬된 폭 제한 모달 */
.checkpay__modal {
    position: relative;
    width: 100%;
    max-width: 420px;
    height: 90vh;
    max-height: 760px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
}
.checkpay__frame {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
}
.checkpay__close {
    position: absolute;
    top: 8px;
    right: 12px;
    z-index: 1;
    font-size: 26px;
    line-height: 1;
    color: #888;
}
.checkpay__progress {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.54);
}
.checkpay__progress .spinner {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 28px;
    width: 28px;
    animation: checkpay-rotate 0.8s infinite linear;
    border: 8px solid #fff;
    border-right-color: transparent;
    border-radius: 50%;
}
@keyframes checkpay-rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
/* 모바일: 전체화면 */
@media (max-width: 599px) {
    .checkpay__modal {
        max-width: none;
        width: 100%;
        height: 100%;
        max-height: none;
        border-radius: 0;
    }
}
</style>
